import { URL_BACK } from '@/config/constants'
import { firstPartUrl } from '@/event/url/url'

export const urlGetStore = 'v1/store/search_ssl'
export const urlGetProduct = 'v1/product/search_product'

export const urlFindAddress = 'v1/address/get_by_user'
export const urlAddressModify = 'v1/address/modify'
export const urlAddressAdd = 'v1/address/add'
export const urlAddressDelete = 'v1/address/delete'

export const urlOrderUpdateCancel = 'v1/order/update-cancel'
export const urlOrderAdd = 'v1/order/add'
export const urlOrderFind = 'v1/order/find'

export const urlCustomerCancelDelete = 'v1/customer/cancel_delete'
export const urlCustomerAdd = 'v1/customer/add'
export const urlCustomerFind = 'v1/customer/find'
export const urlConfirmRegister = 'v1/customer/confirm-register'
export const urlCustomerUpdatePassword = 'v1/customer/update-password'
export const urlCustomerGetOtp = 'v1/customer/get-otp'
export const urlCustomerVerifyOtp = 'v1/customer/verify-otp'
export const urlCustomerUpdate = 'v1/customer/update'
export const urlCustomerDelete = 'v1/customer/delete'
export const urlCustomerVerify = 'v1/customer/verify'
export const urlCustomerModifyPassword = 'v1/customer/modify-password'
export const urlCustomerLogin = 'v1/customer/login'
export const urlCustomerForgetPassword = 'v1/customer/forget-password'

export const urlJwtRefreshToken = 'v1/refresh-token'

export const urlCsrfToken = `${firstPartUrl}://${URL_BACK}/api/v1/csrf-token`

export const urlStripeCreateCheckout = 'v1/stripe/create-checkout-session'

export const urlChangeTheme = 'v1/setting/change-theme'

// V2 Endpoints

/// Customer Endpoints
export const urlCustomerLoginV2 = 'v2/customer/login'
export const urlRefreshTokentV2 = 'v2/customer/me'
export const urlCustomerDisconnectV2 = 'v2/customer/disconnect'

export const urlCustomerGetOtpV2 = 'v2/customer/get-otp'
export const urlCustomerVerifyOtpV2 = 'v2/customer/verify-otp'
export const urlCustomerUpdateV2 = 'v2/customer/update'
export const urlCustomerUpdatePasswordV2 = 'v2/customer/update-password'
export const urlCustomerDeleteV2 = 'v2/customer/delete'

export const urlCustomerDeleteAddressV2 = 'v2/customer/delete-address'
export const urlCustomerAddAddressV2 = 'v2/customer/add-address'
export const urlCustomerModifyAddressV2 = 'v2/customer/modify-address'
export const urlCustomerDefaultAddressV2 = 'v2/customer/default-address'
export const urlCustomerUpdateAddressV2 = 'v2/customer/update-address'

export const urlStripeCreateCheckoutV2 = 'v2/stripe/create-checkout-session'

export const urlOrderAddV2 = 'v2/order/add'
